import { client } from 'clients/eyekia';
import { Category, DefaultInteractionType, DefaultInteractions } from '@sophya/eyekia';
import { BaseStore } from './BaseStore';
import { EditableSelect, EditableValue } from './editor/EditableValue';

export class CategoryDO extends BaseStore {
  constructor(public id: string) {
    super();
    this.name = new EditableValue('name', '', () => {});
    this.thumbnail = new EditableValue('thumbnail', '', () => {});
    this.rank = new EditableValue('rank', 0, () => {})
    this.defaultInteraction = new EditableSelect<DefaultInteractionType | null>(
      'defaultInteraction',
      null,
      () => {},
      // allow selecting none (null)
      [...DefaultInteractions, null],
    );
  }

  name: EditableValue<string>;

  thumbnail: EditableValue<string>;

  rank: EditableValue<number>;

  // Optional default interaction enforced by the category
  defaultInteraction: EditableSelect<DefaultInteractionType | null>;

  updateFromSchema(category: Category): CategoryDO {
    this.name = new EditableValue('name', category.name ?? '', () => {});
    this.thumbnail = new EditableValue('thumbnail', category.thumbnail ?? '', () => {});
    this.rank = new EditableValue('rank', category.rank ?? 0, () => {});
    this.defaultInteraction = new EditableSelect<DefaultInteractionType | null>(
      'defaultInteraction',
      category.defaultInteraction ?? null,
      () => {},
      [...DefaultInteractions, null],
    );
    return this;
  }

  toSchema(): Category {
    let thumbnail = this.thumbnail?.value ? { thumbnail: this.thumbnail.value } : {};
    return {
      name: this.name.value,
      rank: this.rank.value,
      // send explicit null to allow clearing defaultInteraction on server
      defaultInteraction: this.defaultInteraction?.value ?? null,
      ...thumbnail,
    };
  }

  handleDispose() {}

  save = async () => {
    await client().v1.categoryUpdate(this.id, {
      //@ts-ignore
      data: this.toSchema(),
    });
  };
}
